import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import './component.scss';
import {toggleElement, toggleClass} from '@fretadao/f-js-dom';

application.register('bus-operator-header', class extends Controller {
  static classes = [ 'spacing' ]
  static targets = [ 'items', 'header' ]

  toggleItems() {
    toggleElement(this.itemsTarget)
    toggleClass(this.headerTarget, this.SpacingClass)
  }
});
